export const PROFILE_EMAIL = "ashok.prjapati97@gmail.com";
export const GITHUB_USERNAME = "AshokPrjapati";
export const LINKEDIN_USERNAME = "ashok-kumar-1778b213b";

export const RESUME_DRIVE_LINK =
  "https://drive.google.com/file/d/1P27IWs5s4X1JBKLqUAMapYS6an5D_wvH/view?usp=sharing";
export const GITHUB_LINK = `https://github.com/${GITHUB_USERNAME}`;
export const LINKEDIN_LINK = `https://www.linkedin.com/in/${LINKEDIN_USERNAME}/`;
